// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oWyrZ2zB3O95kan5s3hk{padding-top:16px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsTimeline/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA","sourcesContent":[".usersContent {\n  padding-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"usersContent": `oWyrZ2zB3O95kan5s3hk`
};
export default ___CSS_LOADER_EXPORT___;
